const seeMoreText = () => {
	const linkSeeMore = document.querySelectorAll('.js-link-see-more');
	if (linkSeeMore) {
		linkSeeMore.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				const targetId = e.currentTarget.getAttribute('data-target');
				const targetEl = document.getElementById(targetId);
				if (targetEl) targetEl.classList.toggle('active');
				e.currentTarget.classList.toggle('hidden');
			});
		});
	}
};

export default seeMoreText;
